import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DiscussionListConfig, Profile } from "../../../../shared";

@Component({
  selector: "created-discussions",
  templateUrl: "./created-discussions.component.html",
})
export class CreatedDiscussionsComponent implements OnInit {
  public profile: Profile;
  public config: DiscussionListConfig = new DiscussionListConfig();

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.parent.data.subscribe((data: { profile: Profile }) => {
      this.profile = data.profile;
      this.config.filters.author = this.profile.username;
    });
  }
}
